import React from "react";
import { FaTwitter, FaLinkedin, FaGithub, FaLink } from "react-icons/fa";
import { Link } from "react-scroll";

const Footer = () => {
  return (
    <footer className="bg-[#0a0a14] border-t border-white/5 text-gray-400">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* About */}
          <div>
            <h3
              className="text-white font-bold text-lg mb-3"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              <span className="text-[#f29f67]">Ayush</span> Rai
            </h3>
            <p className="text-sm leading-relaxed text-gray-500">
              Motivated full-stack developer with strong experience in web development,
              the MERN stack, FastAPI, and modern backend tools. Passionate about
              crafting scalable and user-centric solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3
              className="text-white font-bold text-sm uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Quick Links
            </h3>
            <ul className="space-y-2">
              {["home", "about", "projects", "techstack", "contact"].map((item) => (
                <li key={item}>
                  <Link
                    to={item}
                    smooth={true}
                    offset={-80}
                    duration={400}
                    className="text-sm text-gray-500 hover:text-[#f29f67] transition-colors cursor-pointer
                      capitalize"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3
              className="text-white font-bold text-sm uppercase tracking-widest mb-4"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              Contact
            </h3>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>
                <a href="mailto:ayushrai803@gmail.com" className="hover:text-[#f29f67] transition-colors">
                  ayushrai803@gmail.com
                </a>
              </li>
              <li>+91 8318542040</li>
              <li>Varanasi, Uttar Pradesh, India</li>
            </ul>

            <div className="flex gap-3 mt-5">
              {[
                { href: "https://x.com/AyushRa36652420", icon: FaTwitter },
                { href: "http://linkedin.com/in/ayush-rai-7109202b6", icon: FaLinkedin },
                { href: "https://github.com/ayush123-bit", icon: FaGithub },
                { href: "https://leetcode.com/u/pepcoderayu/", icon: FaLink },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg flex items-center justify-center
                    bg-white/5 text-gray-400 hover:bg-[#f29f67] hover:text-white
                    transition-all duration-200 hover:-translate-y-0.5"
                >
                  <social.icon size={15} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 border-t border-white/5 flex flex-col sm:flex-row
          items-center justify-between gap-3">
          <p className="text-xs text-gray-600">
            © 2025 Ayush Rai. All Rights Reserved.
          </p>
          <p className="text-xs text-gray-600">
            Built with <span className="text-[#f29f67]">React</span> &amp; <span className="text-[#3b8ff3]">Tailwind CSS</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;